/**
 * Render size for the `RewardsTracker`. Drives layout density and which label form each node shows
 * (Desktop = `$threshold + label`; Mobile = label only). Matches the Figma `size` axis.
 */
export enum RewardsTrackerSize {
  Desktop = 'desktop',
  Mobile = 'mobile'
}
